import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import { useRedirectHome } from '../../../hooks/useRedirectHome';


type Props = {
  navigateHandler?: () => void
  modify: boolean,
  onModifyChange: (value: boolean) => void
  refetchSearch: () => void
  onOpenFilters?: () => void
}
function HeaderNavigation({ navigateHandler, modify, onModifyChange, refetchSearch, onOpenFilters }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  const redirectHome = useRedirectHome();

   

  const handleNavigate = () => {
  const isResultsPage = window.location.pathname === "/search-listings/road";

  if (isResultsPage) {
    redirectHome();
    return;
  }

  navigateHandler ? navigateHandler() : navigate(-1);
};

  return (
      isMobile ? (
          <MobileHeader navigateHandler={handleNavigate} modify={modify} onModifyChange={onModifyChange} refetchSearch={refetchSearch} onOpenFilters={onOpenFilters} />
      ) : (
          <DesktopHeader navigateHandler={handleNavigate} modify={modify} onModifyChange={onModifyChange} refetchSearch={refetchSearch} />
      )
  )
}

HeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default HeaderNavigation;
